import { defineStore } from 'pinia'

import { StorageHelper } from '@/helpers/storage-helper'
import { RepositoryFactory } from '@/repositories/repositoryFactory'

interface AppError {
  message: string
}

interface TradingPageData {
  data: any
  loading: boolean
  error: AppError | null
  initialized: boolean
}

const tradingPageRepository: any = RepositoryFactory.get('tradingPageRepository')

export const useTradingPageStore = defineStore('eduation', {
  state: () =>
    <TradingPageData>{
      data: StorageHelper.getItem('tradingData', []),
      loading: true,
      error: null,
      initialized: false,
    },
  getters: {
    getTradingPageData: (state) => state.data,
    getTradingPageLoading: (state) => state.loading
  },
  actions: {
    async fetchTradingPageTypeOneComponents(
      slug: string,
      template: string = 'trading_template_one'
    ) {
      this.loading = true
      try {
        const response = await tradingPageRepository.getPageTypeOneBySlug({}, slug, template)
        this.data = response.data
        StorageHelper.setItem('tradingData', this.data)
        this.initialized = true
      } catch (error) {
        this.initialized = true
        console.error('Error fetching:', error)
        this.error = {
          message: 'Problem with fetching menu'
        }
        throw error
      } finally {
        this.initialized = true
        this.loading = false
      }
    }
  }
})
